export default "__VITE_ASSET__DmOf5Hw2__"